module.exports = __webpack_public_path__ + "static/media/loginImg.23b508be.gif";